module.exports = __webpack_public_path__ + "img/location.04c9a25e.svg";